module.exports = __webpack_public_path__ + "img/RORBPJR40051.3cb5f8d2.png";